<h1 mat-dialog-title>Données non sauvegardées</h1>
<div mat-dialog-content>
	<p>
		La page contient des changements que vous n'avez pas sauvegardé, les changements seront perdu, souhaitez-vous
		continuer ?
	</p>
</div>
<div mat-dialog-actions>
	<button mat-raised-button color="primary" cdkFocusInitial [mat-dialog-close]="false">Non</button>
	<button mat-button [mat-dialog-close]="true">Oui</button>
</div>
